import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';
import ProductItem from '../productItem/ProductItem.vue';
import { useI18n } from 'vue-i18n';
import { useLess } from '@/models/hooks';
import constants, { encryptedMarketplaceId } from '@/constants';
import { getRecommendAsins, RECOMMENDATION_TYPE } from '@/models/api/asinsRecommendationsAndOrderRaisingApi';
import { getAsinBatch } from '@/models/api/detailPageApi';
const pageSize = 10;
export default {
  __name: 'RecommendedAsins',
  props: {
    title: {
      type: String
    },
    columns: {
      type: Number,
      default: () => 2
    },
    backgroundColor: {
      type: String,
      default: () => ''
    },
    isInDetailPage: {
      type: Boolean,
      default: () => false
    },
    category: {
      type: String,
      default: () => ''
    },
    categoryId: {
      type: String,
      default: () => ''
    }
  },
  emits: ['onAddCartConfirm', 'reloadingDetailPageData', 'openApp', 'isLoading'],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    useLess('components/RecommendedAsins.less');
    const {
      t
    } = useI18n();
    const isListloading = ref(false);
    const isFinished = ref(false);
    const recommendedAsinList = ref([]);
    const pageIndex = ref('');
    const getSearch = async (isRefresh = false) => {
      if (isRefresh) pageIndex.value = '';
      try {
        var _data$pagination, _data$pagination2, _data$pagination3;
        const {
          data
        } = await getRecommendAsins({
          language: constants.ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[constants.ENCRYPTED_MARKETPLACE_ID],
          recommendationType: RECOMMENDATION_TYPE.CATEGORY,
          recommendationTypeId: props.category,
          exclusiveStartKey: encodeURIComponent(pageIndex.value),
          pageSize
        });
        if (!(data !== null && data !== void 0 && (_data$pagination = data.pagination) !== null && _data$pagination !== void 0 && _data$pagination.lastEvaluatedKey)) isFinished.value = true;
        if (data !== null && data !== void 0 && data.asinList) {
          const {
            data: asinData
          } = await getAsinBatch({
            ids: data === null || data === void 0 ? void 0 : data.asinList.toString(),
            marketplace: encryptedMarketplaceId,
            withCache: false,
            allowOtherOffer: false,
            returnableFlagSkipped: false
          });
          if (isRefresh) {
            recommendedAsinList.value = [];
          }
          asinData === null || asinData === void 0 ? void 0 : asinData.forEach(item => {
            if (item.selectionEligible) {
              var _item$ourPrice, _item$ourPrice$amount, _constants$MERCHANT_B;
              recommendedAsinList.value.push({
                ...item,
                asin: item.asin,
                merchantId: item.merchantId,
                isGlobalStoreFreeShippingProgram: item.delivery.isGlobalStoreFreeShippingProgram,
                buyPrice: item === null || item === void 0 ? void 0 : (_item$ourPrice = item.ourPrice) === null || _item$ourPrice === void 0 ? void 0 : (_item$ourPrice$amount = _item$ourPrice.amount) === null || _item$ourPrice$amount === void 0 ? void 0 : _item$ourPrice$amount.toFixed(2),
                title: item.title,
                mainImage: item.mainImage,
                gsBadge: (_constants$MERCHANT_B = constants.MERCHANT_BADGE_MAP[item.merchantId]) === null || _constants$MERCHANT_B === void 0 ? void 0 : _constants$MERCHANT_B.badgeURL
              });
            }
          });
        }
        emit('isLoading', true, !(data !== null && data !== void 0 && (_data$pagination2 = data.pagination) !== null && _data$pagination2 !== void 0 && _data$pagination2.lastEvaluatedKey));
        if (data !== null && data !== void 0 && (_data$pagination3 = data.pagination) !== null && _data$pagination3 !== void 0 && _data$pagination3.lastEvaluatedKey) {
          var _data$pagination4;
          pageIndex.value = data === null || data === void 0 ? void 0 : (_data$pagination4 = data.pagination) === null || _data$pagination4 === void 0 ? void 0 : _data$pagination4.lastEvaluatedKey;
        }
      } catch (error) {
        isFinished.value = true;
        console.error(error, 'api---error---getRecommendAsins');
      }
    };
    const onLoad = async () => {
      emit('isLoading', false, !pageIndex.value);
      await getSearch();
      isListloading.value = false;
    };
    const onPullRefresh = () => {
      pageIndex.value = '';
      recommendedAsinList.value = [];
      onLoad();
    };
    const onAddCartConfirm = (status, asin) => {
      emit('onAddCartConfirm', status, asin);
    };
    __expose({
      onPullRefresh,
      getSearch
    });
    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", {
        class: "recommended-asins",
        style: _normalizeStyle({
          background: __props.backgroundColor
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(["title", {
          'title-detail': __props.isInDetailPage
        }])
      }, _toDisplayString(__props.title ? __props.title : _unref(t)('common.RECOMMENDED_COMMODITIES')), 3), _createVNode(_component_van_list, {
        loading: isListloading.value,
        "onUpdate:loading": _cache[3] || (_cache[3] = $event => isListloading.value = $event),
        finished: isFinished.value,
        "finished-text": _unref(t)('modules.detailPage.NO_MORE'),
        "loading-text": _unref(t)('modules.commonComponent.pullRefresh.LOADING'),
        onLoad: onLoad
      }, _createSlots({
        default: _withCtx(() => [_createVNode(ProductItem, {
          asinList: recommendedAsinList.value,
          "onUpdate:asinList": _cache[0] || (_cache[0] = $event => recommendedAsinList.value = $event),
          columns: __props.columns,
          isShowUnit: true,
          onAddCartConfirm: onAddCartConfirm,
          onReloadingDetailPageData: _cache[1] || (_cache[1] = $event => emit('reloadingDetailPageData')),
          onOpenApp: _cache[2] || (_cache[2] = $event => emit('openApp'))
        }, null, 8, ["asinList", "columns"])]),
        _: 2
      }, [_ctx.$slots.loading ? {
        name: "loading",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "loading")]),
        key: "0"
      } : undefined]), 1032, ["loading", "finished", "finished-text", "loading-text"])], 4);
    };
  }
};